import React, { useState } from 'react';
import UserManagement from './UserManagement';
import ConferenceManagement from './ConferenceManagement';
import NewsManagement from './NewsManagement';
import PaperManagement from './PaperManagement';
import BoardManagement from './BoardManagement';

/**
 * AdminDashboard Component
 * 
 * Main dashboard for admin users to manage different aspects of the system.
 * This component acts as a container for various management modules:
 * - User Management
 * - Conference Management
 * - News Management
 * - Paper Management (placeholder)
 * - Reports & Analytics (placeholder)
 * 
 * @component
 */
const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('conferences');

    return (
        <div className="container py-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1 className="h3 mb-0">Admin Dashboard</h1>
                        <div className="badge bg-primary fs-6">
                            Administrator
                        </div>
                    </div>

                    {/* Navigation Tabs */}
                    <ul className="nav nav-tabs mb-4" role="tablist">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'conferences' ? 'active' : ''}`}
                                onClick={() => setActiveTab('conferences')}
                            >
                                <i className="bi bi-calendar-event me-2"></i>
                                Conferences
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'news' ? 'active' : ''}`}
                                onClick={() => setActiveTab('news')}
                            >
                                <i className="bi bi-newspaper me-2"></i>
                                News
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'papers' ? 'active' : ''}`}
                                onClick={() => setActiveTab('papers')}
                            >
                                <i className="bi bi-file-earmark-text me-2"></i>
                                Papers
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'users' ? 'active' : ''}`}
                                onClick={() => setActiveTab('users')}
                            >
                                <i className="bi bi-people me-2"></i>
                                Users
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'board' ? 'active' : ''}`}
                                onClick={() => setActiveTab('board')}
                            >
                                <i className="bi bi-diagram-3 me-2"></i>
                                Board
                            </button>
                        </li>
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {activeTab === 'users' && <UserManagement />}
                        {activeTab === 'conferences' && <ConferenceManagement />}
                        {activeTab === 'news' && <NewsManagement />}
                        {activeTab === 'papers' && <PaperManagement />}
                        {activeTab === 'board' && <BoardManagement />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;